"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.ConfigEnvironment = void 0;
var ConfigEnvironment;
(function (ConfigEnvironment) {
    ConfigEnvironment["local"] = "local";
    ConfigEnvironment["development"] = "development";
    ConfigEnvironment["production"] = "production";
})(ConfigEnvironment = exports.ConfigEnvironment || (exports.ConfigEnvironment = {}));
var trackingBackendUrlDev = "http://localhost:4041"; //url of tracking backend
var trackingBackendUrl = "https://technis-application-tracking-dot-technis-application-tracking.ew.r.appspot.com"; //url of tracking backend
var apiUrl = "/api";
var local = {
    trackingBackendUrl: trackingBackendUrl,
    trackingBackendUrlDev: trackingBackendUrlDev,
    trackingApiUrl: "".concat(trackingBackendUrl).concat(apiUrl),
    trackingApiUrlDev: "".concat(trackingBackendUrlDev).concat(apiUrl),
    env: ConfigEnvironment.local,
    projectId: "technis-tracking-library",
};
var getEnvConfig = function () {
    switch (process.env.NODE_ENV) {
        default:
            return local;
    }
};
exports.config = Object.assign({}, getEnvConfig());
